// Componente que muestra y linkea las secciones de admin.

import {FaUserEdit} from "react-icons/fa";
import {FaClipboardList} from "react-icons/fa";
import {FaLayerGroup} from "react-icons/fa";
import {FaCalculator} from "react-icons/fa";
import {Link} from "react-router-dom";

const AdminBody = () => {
    return(
        <div>
            <div className="admin__body">
                <Link to={"/dashboard/admin/users"} style={{color: 'inherit', textDecoration: 'inherit'}}>
                    <div className="admin__body__section">
                        <h3 className="admin__body__section__title">
                            Usuarios
                        </h3>
                        <FaUserEdit className="admin__body__section__logo"/>
                    </div>
                </Link>
                <Link to={"/dashboard/admin/ordenes"} style={{color: 'inherit', textDecoration: 'inherit'}}>
                    <div className="admin__body__section">
                        <h3 className="admin__body__section__title">
                            Órdenes
                        </h3>
                        <FaClipboardList className="admin__body__section__logo"/>
                    </div>
                </Link>
                <Link to={"/dashboard/admin/dimensiones"} style={{color: 'inherit', textDecoration: 'inherit'}}>
                    <div className="admin__body__section">
                        <h3 className="admin__body__section__title">
                            Dimensiones
                        </h3>
                        <FaLayerGroup className="admin__body__section__logo"/>
                    </div>
                </Link>
                <Link to={"/dashboard/admin/precios"} style={{color: 'inherit', textDecoration: 'inherit'}}>
                    <div className="admin__body__section">
                        <h3 className="admin__body__section__title">
                            Calculadora de precios
                        </h3>
                        <FaCalculator className="admin__body__section__logo"/>
                    </div>
                </Link>
            </div>
            <hr></hr>
        </div>
    )
}

export default AdminBody;